import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormRepoService } from "../services/form-repo.service";
import { PageHeaderComponent } from "../../shared/page-header/page-header.component";
import {
  LoadingIndicatorModule,
  WSSyncFusionGridComponent,
  WSSyncFusionGridModule,
} from "wspowerpack";
import { FormLabelComponent } from "../../shared/form-label/form-label.component";
import { ReactiveFormsModule } from "@angular/forms";
import { AccountClient, AccountV1Model } from "src/app/api/client";
import { AuthService } from "../../core/services/auth.service";

@Component({
  selector: "app-demo",
  standalone: true,
  imports: [
    CommonModule,
    PageHeaderComponent,
    LoadingIndicatorModule,
    FormLabelComponent,
    ReactiveFormsModule,
    WSSyncFusionGridModule,
  ],
  templateUrl: "./demo.component.html",
  styleUrls: ["./demo.component.scss"],
})
export class DemoComponent {
  account: AccountV1Model;
  currentAccountId: number;
  isLoading = true;
  expirationDate: Date;
  constructor(
    private formRepoService: FormRepoService,
    private authService: AuthService,
    private accountClient: AccountClient
  ) {}

  ngOnInit(): void {
    this.loadAccount();
  }

  loadAccount(): void {
    this.isLoading = true;
    this.currentAccountId = this.authService.user?.currentAccountId!;
    this.accountClient.getById(this.currentAccountId).subscribe((data) => {
      this.account = data;
      this.expirationDate = new Date(
        this.account.expiration!.getFullYear(),
        this.account.expiration!.getMonth(),
        this.account.expiration!.getUTCDate()
      );
      console.log(this.account);
      this.isLoading = false;
    });
  }

  // onSubmitClicked(): void {}
}
